module.exports = CodeMirror;